import * as Popover from '@radix-ui/react-popover';
import React, { useEffect, useRef } from 'react';
import { useTheme } from 'styled-components';
import { Box } from '../Box/Box';
import { CloseButton } from '../CloseButton/CloseButton';
import { ThemeProvider } from '../ThemeProvider/ThemeProvider';
import Overlay from './Overlay';
import { FixedCloseButton, StyledArrow } from './Popover.styles';
function parsePlacement(placement) {
  const match = /([a-z]+)-?([a-z]+)?/.exec(placement);
  if (match) {
    return {
      // @ts-ignore
      side: match[1],
      // @ts-ignore
      align: match[2]
    };
  }
}
const DsPopover = ({
  borderRadius = 'xl',
  children,
  color = 'background.lightest',
  hideArrow,
  hideOverlay = false,
  hideCloseButton = false,
  idx,
  isOpen,
  onClose,
  onOpen,
  openOnMount,
  openOnHover,
  overlayOpacity = 0.5,
  p,
  placement = 'top',
  toggleIsOpenOnClick = true,
  renderContent,
  width,
  maxWidth
}) => {
  const [isOpenState, setIsOpenState] = React.useState(openOnMount || isOpen);
  const theme = /*#__PURE__*/useTheme();
  const firstUpdate = useRef(true);
  useEffect(() => {
    // When using openOnMount, we don't want to update the open state on the first render.
    // This would cause the overlay to be hidden if isOpen is falsy.
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    if (isOpen !== isOpenState) {
      setIsOpenState(isOpen);
    }
  }, [isOpen]);
  function handleOnOpenChange(open) {
    // Handle the controlled state when we want to force the popover open
    if (isOpen) {
      return;
    }
    setIsOpenState(open);
    if (open) {
      onOpen?.();
    } else {
      onClose?.();
    }
  }
  function handleTriggerClick(event) {
    if (!toggleIsOpenOnClick) {
      event.preventDefault();
    }
  }
  function handleMouseEnter() {
    if (openOnHover) {
      setIsOpenState(true);
    }
  }
  function handleMouseLeave() {
    if (openOnHover) {
      setIsOpenState(false);
    }
  }
  const {
    side,
    align
  } = parsePlacement(placement);
  return React.createElement(Popover.Root, {
    open: isOpenState,
    onOpenChange: handleOnOpenChange,
    defaultOpen: openOnMount
  }, React.createElement(Popover.Trigger, {
    asChild: true,
    onClick: handleTriggerClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, children), React.createElement(Popover.Portal, null, React.createElement(Popover.Content, {
    sideOffset: 5,
    side: side,
    align: align,
    id: idx
  }, React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Box, {
    color: color,
    boxShadowSize: 'overlay-md',
    borderRadius: borderRadius,
    p: p,
    width: width,
    maxWidth: maxWidth
  }, renderContent, !hideCloseButton && React.createElement(FixedCloseButton, null, React.createElement(CloseButton, {
    as: Popover.Close,
    "aria-label": 'Close',
    variant: 'filled',
    size: 'sm',
    onClick: handleOnOpenChange.bind(null, false)
  })), !hideArrow && React.createElement(StyledArrow, {
    as: Popover.Arrow,
    color: color
  }))))), !(hideOverlay || openOnHover) && React.createElement(Overlay, {
    overlayOpacity: overlayOpacity,
    isOpen: isOpenState
  }));
};
// Old Popover props todo:
// onBeforeOpen: PropTypes.func,
// onBeforeClose: PropTypes.func,
// Currently broken in plcn-popover:
// borderColor: PropTypes.string,
export { DsPopover as Popover };